export const phoneNumCheck = (phonenum,msg,indentCodeBtn) => {
    let reg = /^1[0-9]{10}$/
    if(!reg.test(phonenum)){
        return false
    }else{
        return true
    }
}

export const identCodeCheck = code => {
    let reg = /^[0-9]{6}$/;
    if(!reg.test(code)){
        return false
    }else{
        return true
    }
}